<template>
  <v-text-field
    v-if="definition.type === 'string'"
    v-model="currentValue"
    :label="definition.label"
    variant="outlined"
    density="compact"
    hide-details
    clearable
    @keydown.enter="emitChange"
    @update:focused="handleChange"
  />
  <v-autocomplete
    v-else-if="definition.type === 'reflist'"
    v-model="currentValue"
    :label="definition.label"
    :items="items"
    :item-value="definition.itemValue"
    :item-title="definition.itemText"
    :multiple="definition.multiple"
    variant="outlined"
    density="compact"
    hide-details
    clearable
    @update:focused="handleChange"
  />
  <span v-else-if="definition.type === 'boolean'" style="display: flex">
    <v-checkbox
      :model-value="currentValue"
      :label="definition.label"
      :indeterminate="currentValue === null || currentValue === undefined"
      :false-value="false"
      :true-value="true"
      variant="outlined"
      density="compact"
      hide-details
      clearable
      @update:modelValue="
        currentValue = $event;
        emitChange();
      "
    />
    <v-btn
      style="margin-top: 6px; margin-left: 4px"
      icon="mdi-cancel"
      variant="plain"
      density="compact"
      @click="
        currentValue = undefined;
        emitChange();
      "
    />
  </span>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { FilterDefinition } from "@/types/filter";
import { useListStore } from "@/store/lists";

const props = defineProps<{
  modelValue: any;
  definition: FilterDefinition;
}>();
const emit = defineEmits(["change"]);

const currentValue = ref<any>(props.modelValue);

const lists = useListStore();
const items = computed(() => {
  if (props.definition.type === "reflist") {
    return lists.useList(props.definition.reflist).value;
  }
  return [];
});

watch(
  () => props.modelValue,
  () => {
    currentValue.value = props.modelValue;
  },
);

const handleChange = (value: boolean) => {
  if (!value && currentValue.value !== props.modelValue) {
    emitChange();
  }
};

const emitChange = () => {
  if (Array.isArray(currentValue.value)) {
    emit("change", currentValue.value.length > 0 ? currentValue.value : null);
  } else if (currentValue.value === true || currentValue.value === false) {
    emit("change", currentValue.value);
  } else {
    emit("change", currentValue.value || null);
  }
};
</script>
